import * as angular from 'angular';
import * as _ from 'lodash';

import { IGroupService } from '../../services';
import { ComponentDefinition } from '../../models';

class WtGroupTypesContoller implements angular.IComponentController {
    groupTypes: string[];
    onSelect: (value: { item, value }) => void;
    onRemove: (value: { item: string }) => void;
    static $inject = ['groupService'];
    constructor(private _groupService: IGroupService) { }

    $onInit() {
        this._groupService.getAll()
            .then(data => {
                const types = data.map(d => d.group).map(d => d.type);
                const uniques = _.chain(types).uniqBy(t => t).sortBy().value();
                this.groupTypes = uniques;
            });
    }

    select($item, $value) {
        if (this.onSelect) {
            this.onSelect({ item: $item, value: $value });
        }
    }
    
    remove($item: string) {
        if (this.onRemove) {
            this.onRemove({ item: $item });
        }
    }
}
export const wtGroupTypes: ComponentDefinition = {
    componentId: 'wtGroupTypes',
    template: require('./multiGroupTypeSelector.component.html'),
    controller: WtGroupTypesContoller,
    controllerAs: 'vm',
    bindings: {
        selectedGroupTypes: '=',
        disabled: '<?',
        onRemove: '&?',
        onSelect: '&?',
    }
};
